"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleWith = exports.onlyIfNotFn = exports.onlyIfFn = exports.cacheAll = void 0;

var identity = function identity(x) {
  return x;
};

var withCache = function withCache(cache, fn, getKey, checkCache) {
  return function () {
    var key = getKey.apply(void 0, arguments);
    if (checkCache && cache.has(key)) return cache.get(key);
    var result = fn.apply(void 0, arguments);
    cache.set(key, result);
    return result;
  };
};

var cacheAll = function cacheAll(fn) {
  var getKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;
  var cache = new Map();
  var cached = withCache(cache, fn, getKey, true);
  cached.force = withCache(cache, fn, getKey, false);
  return cached;
};

exports.cacheAll = cacheAll;

var onlyIfFn = function onlyIfFn(value, def) {
  return typeof value === 'function' ? value : def;
};

exports.onlyIfFn = onlyIfFn;

var onlyIfNotFn = function onlyIfNotFn(value, def) {
  return typeof value !== 'function' ? value : def;
};

exports.onlyIfNotFn = onlyIfNotFn;

var handleWith = function handleWith() {
  for (var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }

  var fnHandlers = handlers.filter(function (handler) {
    return typeof handler === 'function';
  });
  return function polyHandler() {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    fnHandlers.forEach(function (handler) {
      return handler.apply(_this, args);
    });
  };
};

exports.handleWith = handleWith;